import React, { useCallback, useRef } from 'react'
import List from 'src/components/grid.component';
import { connect } from 'react-redux';
import { useParams } from 'react-router-dom';
import {NumberFormatter, TransactionState, TransactionTime } from '../service';


const renderNumberColumn = (key) => (cellProps) => {
  const value = cellProps?.dataItem?.[key] || "0";
    return <NumberFormatter value={value} />;
  };

const TransactionInformationdGrid = (props) => {
  const gridRef = useRef(null);
  const params = useParams();
  const transactionTime = useCallback((props) => {
    return <TransactionTime data={props?.dataItem} />
  }, [])
  const transactionState = useCallback((props) => {
    return <TransactionState data={props?.dataItem} />
  }, [])
  const customcells = {
    "time": transactionTime,
    "amount": renderNumberColumn("amount"),
    "beforeAmount": renderNumberColumn("beforeAmount"),
    "afterAmount":renderNumberColumn("afterAmount"),
    "state": transactionState,
  };
  const renderCustomCell = useCallback((props, column) => {
    if (customcells[column.field]) {
      return customcells[column.field](props);
    }
  }, [customcells]);
  return (
    <div className=''>
      <List
        url={process.env.REACT_APP_GRID_API + `api/CardsManageService/TransactionInfor/${params?.id}`}
        pSize={10}
        className="custom-grid"
        ref={gridRef}
        showExcelExport={props?.isExcelexport}
        screenName={'Card_Transactions'}
        renderCustomCell={renderCustomCell}
        showDisplayColumns={false}
      />
    </div>
  )
}
const connectStateToProps = ({ oidc }) => {
  return { userDetails: oidc?.profile.profile }
}
export default connect(connectStateToProps)(TransactionInformationdGrid);
